import * as React from 'react'
import { ActionIcon } from '@mantine/core'

// 社区行政村减灾能力
const SvgComponent = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 26"
    class="design-iconfont"
    width={width}
    height={height}
  >
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="98.993048%"
        id="kdaucrbui__6zcd7jz1kb"
      >
        <stop stop-color="#71ECDA" offset="0%" />
        <stop stop-color="#32B8C0" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="kdaucrbui__ouoffw66qa"
      >
        <stop stop-color="#98F3E7" offset="0%" />
        <stop stop-color="#66D0D5" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        d="M10.7586207,1 C13.4527454,1 15.8915589,2.09863836 17.6570109,3.87410315 C19.424504,5.65162062 20.5172414,8.10737032 20.5172414,10.8196383 C20.5172414,13.2054308 19.0111003,16.1209359 17.1884092,18.6927443 C14.8576982,21.9813662 11.9231088,25 10.7586207,25 C9.59413261,25 6.6595432,21.9813662 4.3288322,18.6927443 C2.50614105,16.1209359 1,13.2054308 1,10.8196383 C1,8.10737032 2.0927374,5.65162062 3.8602305,3.87410315 C5.62568251,2.09863836 8.06449597,1 10.7586207,1 Z"
        stroke="url(#kdaucrbui__ouoffw66qa)"
        stroke-width="2"
        fill="url(#kdaucrbui__6zcd7jz1kb)"
      />
      <path
        d="M10.0862069,10.7586207 L0.672413793,10.7586207 C0.30104991,10.7586207 0,10.4575708 0,10.0862069 L0,8.06896552 C0,7.69760163 0.30104991,7.39655172 0.672413793,7.39655172 L0.672413793,4.70689655 C0.38169371,4.70503545 0.125094607,4.51654761 0.0363773723,4.23968866 C-0.0523398627,3.9628297 0.0469197439,3.66030979 0.282413793,3.48982759 L4.98931034,0.127758621 C5.22274841,-0.038447299 5.53587228,-0.038447299 5.76931034,0.127758621 L10.4762069,3.48982759 C10.7117009,3.66030979 10.8109606,3.9628297 10.7222433,4.23968866 C10.6335261,4.51654761 10.376927,4.70503545 10.0862069,4.70689655 L10.0862069,7.39655172 C10.4575708,7.39655172 10.7586207,7.69760163 10.7586207,8.06896552 L10.7586207,10.0862069 C10.7586207,10.4575708 10.4575708,10.7586207 10.0862069,10.7586207 Z M1.34482759,9.4137931 L9.4137931,9.4137931 L9.4137931,8.74137931 L1.34482759,8.74137931 L1.34482759,9.4137931 Z M7.39655172,7.39655172 L8.74137931,7.39655172 L8.74137931,4.70689655 L7.39655172,4.70689655 L7.39655172,7.39655172 Z M4.70689655,7.39655172 L6.05172414,7.39655172 L6.05172414,4.70689655 L4.70689655,4.70689655 L4.70689655,7.39655172 Z M2.01724138,7.39655172 L3.36206897,7.39655172 L3.36206897,4.70689655 L2.01724138,4.70689655 L2.01724138,7.39655172 Z M2.77034483,3.36206897 L7.98827586,3.36206897 L5.37931034,1.49948276 L2.77034483,3.36206897 Z"
        fill="#F7FFFF"
        transform="translate(5.37931 5.37931)"
        fill-rule="nonzero"
      />
    </g>
  </svg>
)

const Icon = (props) => {
  const {
    fill = '#0152D9',
    variant = 'transparent',
    size = 20,
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <SvgComponent width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default Icon
